module.exports = __webpack_public_path__ + "a365938f97da363653114e5f34e0d9ca.MP3";